<template>
    <div
        class="modal fade overflow-inherit-y"
        :class="[props.className]"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        :aria-label="props.title"
        :id="computedId"
        ref="_modalElement"
        @keydown.enter.prevent="handleEnter"
        @keydown.escape.prevent="_hide()">
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            :style="`max-width: ${props.width}`">
            <div
                class="modal-content"
                style="overflow: visible">
                <div class="modal-header">
                    <h4 class="modal-title">{{ props.title }}</h4>
                    <button
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                        @click.prevent="model = false"></button>
                </div>
                <div
                    class="modal-body"
                    :class="modalBodyContainerClass">
                    <p>
                        <slot
                            name="body"
                            :on-dismiss="handleDismiss"
                            :on-submit="handleSubmit"
                            >{{ props.body }}</slot
                        >
                        <slot></slot>
                    </p>
                </div>
                <div
                    class="modal-footer"
                    v-if="props.showFooter">
                    <slot
                        name="footer"
                        :on-dismiss="handleDismiss"
                        :on-submit="handleSubmit"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import {onMounted, ref, useId, useTemplateRef, watch} from "vue";
import {Modal} from "bootstrap";

const computedId = useId();
const model = defineModel();
const props = withDefaults(
    defineProps<{
        showModal?: boolean;
        title?: string;
        body?: string;
        showFooter?: boolean;
        className?: string;
        width?: string;
        modalBodyContainerClass?: string;
    }>(),
    {
        showModal: false,
        title: "",
        width: "750px",
        modalBodyContainerClass: "",
    }
);

const modalElement = useTemplateRef<HTMLElement | null>("_modalElement");
const modelObject = ref<Modal>();

const state = ref(false);

onMounted(() => {
    modelObject.value = new Modal(modalElement.value!, {keyboard: false});
});

const emit = defineEmits<{
    (event: "dismiss"): void;
    (event: "submit"): void;
}>();

function handleDismiss() {
    emit("dismiss");
}

function handleSubmit() {
    emit("submit");
}

function _show() {
    state.value = true;
    modelObject.value!.show();
}

function _hide() {
    state.value = false;
    modelObject.value!.hide();
    model.value = false;
    emit("dismiss");
}

function handleEnter(event:any) {  
    emit("submit");
}

watch(
    () => props.showModal,
    (showModal, prevShowModal) => {
        state.value = showModal;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        state.value = showModal as boolean;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

defineExpose({show: _show});
</script>
<style lang="css">
.overflow-inherit-y {
    overflow-y: inherit !important;
}
</style>
